module.exports = __webpack_public_path__ + "img/news-09.da1bb613.jpg";